var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseInfoDetail',[_c('dl',{staticClass:"fee-estimate"},[_c('div',{staticClass:"term-group"},[_c('dt',[_vm._v("Registration fee estimate")]),_c('dd',[_vm._v(_vm._s(_vm.estimate))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }